import React from 'react'

export const HighlightCell = ({ value, searchText }) => {
    if (value == null || value === '') return null
    const str = String(value)
    if (!searchText) return str

    const lowerStr = str.toLowerCase()
    const lowerSearch = String(searchText).toLowerCase()
    const parts = []
    let cursor = 0
    let idx = lowerStr.indexOf(lowerSearch, cursor)

    while (idx !== -1) {
        if (idx > cursor) parts.push(str.slice(cursor, idx))
        parts.push(
            <mark key={idx} style={{ backgroundColor: '#ffe680', padding: 0 }}>
                {str.slice(idx, idx + lowerSearch.length)}
            </mark>
        )
        cursor = idx + lowerSearch.length
        idx = lowerStr.indexOf(lowerSearch, cursor)
    }
    if (cursor < str.length) parts.push(str.slice(cursor))

    return <>{parts}</>
}

export default HighlightCell